import { Col, Row } from 'react-bootstrap';
const UtilisedAvailable = ({type,activePeriodiciti,handleParticulars,kORCommaFormatter}) => {
    return (
    <Row
      className={`g-0 ${
        type === 'watchlist' ? 'mb-3' : 'mt-3'
      } utilised-available-funds-wrap`}
    >
      <Col
        className="utilised-funds-wrap d-flex flex-column justify-content-start align-items-start cursor-pointer"
        onClick={() => handleParticulars(activePeriodiciti?.data[0])} data-testid={`${type}-funds-modal-utilised-funds-label`}
      >
        <div className="font-regular font-size1 utilised-available-textcolor">
          Utilised Margin
        </div>
        <div className="font-regular font-size4 utilised-available-textcolor">
          {' '}
          {kORCommaFormatter('Total_Utilization', 'single')}
        </div>
      </Col>
      <Col
        className="available-funds-wrap d-flex flex-column justify-content-start align-items-start cursor-pointer"
          onClick={() => handleParticulars(activePeriodiciti?.data[0])} data-testid={`${type}-funds-modal-available-funds-label`}
      >
        <div className="font-regular font-size1 utilised-available-textcolor">
          Available Margin
        </div>
        <div className="font-regular font-size4 utilised-available-textcolor">
        {kORCommaFormatter('Net_Available_Funds', 'both')}
        </div>
      </Col>
    </Row>
  );
};
export default UtilisedAvailable;
